import React, { Component } from 'react';
import { 
  Box, 
  Button, 
  Typography, 
  Card, 
  CardContent, 
  Alert,
  CircularProgress
} from '@mui/material';
import { 
  BugReport, 
  Lightbulb, 
  Build, 
  Assignment, 
  OpenInNew,
  CheckCircle
} from '@mui/icons-material';

class JiraForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isRedirecting: false
    };
  }

  // The direct Jira form URL
  jiraFormUrl = 'https://myjoulebox.atlassian.net/jira/software/projects/COMPTA/form/36?atlOrigin=eyJpIjoiZWJkMTgxNTJhNWFjNGQ5MDllNGE4YTY2ZjAwODYzNGYiLCJwIjoiaiJ9';

  handleRedirect = () => {
    this.setState({ isRedirecting: true });
    // Open in new tab
    window.open(this.jiraFormUrl, '_blank');
    // Reset state after a short delay
    setTimeout(() => {
      this.setState({ isRedirecting: false });
    }, 1000);
  };

  render() {
    const { isRedirecting } = this.state;

    return (
      <Card sx={{ maxWidth: 600, mx: 'auto', mt: 4 }}>
        <CardContent sx={{ textAlign: 'center', py: 4 }}>
          <Box sx={{ mb: 3 }}>
            <Typography variant="h4" gutterBottom>
              Demander une Nouvelle Fonctionnalité
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              Aidez-nous à améliorer l'application en soumettant vos demandes de nouvelles fonctionnalités et suggestions d'amélioration.
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 4, justifyContent: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 2, border: '1px solid #e0e0e0', borderRadius: 2 }}>
              <Lightbulb sx={{ color: '#4caf50' }} />
              <Typography variant="body2">Nouvelles Fonctionnalités</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 2, border: '1px solid #e0e0e0', borderRadius: 2 }}>
              <Build sx={{ color: '#2196f3' }} />
              <Typography variant="body2">Améliorations</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 2, border: '1px solid #e0e0e0', borderRadius: 2 }}>
              <Assignment sx={{ color: '#ff9800' }} />
              <Typography variant="body2">Grandes Fonctionnalités</Typography>
            </Box>
          </Box>

          <Alert severity="warning" sx={{ mb: 2, textAlign: 'left' }}>
            <Typography variant="body2">
              <strong>⚠️ Pour signaler un bug :</strong><br/>
              Utilisez le bouton "Signaler un bug" (icône de bug) disponible dans l'interface de l'application.
            </Typography>
          </Alert>

          <Alert severity="info" sx={{ mb: 3, textAlign: 'left' }}>
            <Typography variant="body2">
              <strong>Que se passe-t-il ensuite ?</strong><br/>
              • Votre demande sera examinée par notre équipe de développement<br/>
              • Vous recevrez des mises à jour par e-mail sur l'avancement<br/>
              • Le problème sera suivi dans notre système de gestion de projet
            </Typography>
          </Alert>

          <Button
            variant="contained"
            size="large"
            startIcon={isRedirecting ? <CircularProgress size={20} /> : <OpenInNew />}
            onClick={this.handleRedirect}
            disabled={isRedirecting}
            sx={{ minWidth: 200, mb: 2 }}
          >
            {isRedirecting ? 'Ouverture du formulaire...' : 'Ouvrir le formulaire de demande'}
          </Button>

          <Typography variant="body2" color="text.secondary">
            Le formulaire s'ouvrira dans un nouvel onglet
          </Typography>
        </CardContent>
      </Card>
    );
  }
}

export default JiraForm;
